<template>
  <router-view />
</template>

<script>
export default {
  name: 'Reason'
}
</script>

<style scoped>

</style>
